import { CustomTemplatedMessageVariables } from 'generated-graphql/types';

export const validateTemplatedInputVariables = ({
  variables,
  value
}: {
  variables: CustomTemplatedMessageVariables[];
  value: string;
}) => {
  // if variable between {{ }} is not in the available variables, return false, else return true
  const variableRegex = /{{(.*?)}}/g;

  const variablesInValue = value.match(variableRegex);

  if (!variablesInValue) return true;

  return variablesInValue.every((variable) => {
    const variableValue = variable.slice(2, -2);

    return variables.some(
      (availableVariable) => availableVariable === variableValue
    );
  });
};

/**
 * Validates multiple templated input fields against available variables
 * @param variables - Array of available variables
 * @param values - Array of string values to validate
 * @returns true if all values contain only valid variables, false otherwise
 */
export const validateMultipleTemplatedInputs = ({
  variables,
  values
}: {
  variables: CustomTemplatedMessageVariables[];
  values: (string | undefined)[];
}) => {
  return values.every((value) => {
    if (!value) return true;
    return validateTemplatedInputVariables({ variables, value });
  });
};
